module.exports = __webpack_public_path__ + "static/media/icon-trash.ef491926.png";